/**
 * TanStack Query Keys
 * Centralized query key definitions for React Query
 * For System Tower (Platform Admin)
 */

export const QUERY_KEYS = {
  // Authentication
  AUTH: {
    ME: ['auth', 'me'] as const,
    MFA_STATUS: ['auth', 'mfa', 'status'] as const,
  },

  // Portals (System-level management)
  PORTALS: {
    ALL: ['portals'] as const,
    LIST: () => ['portals', 'list'] as const,
    DETAIL: (id: string) => ['portals', 'detail', id] as const,
    ANALYTICS: (id: string) => ['portals', 'analytics', id] as const,
  },

  // System Admins
  SYSTEM_ADMINS: {
    ALL: ['system-admins'] as const,
    LIST: () => ['system-admins', 'list'] as const,
    DETAIL: (id: string) => ['system-admins', 'detail', id] as const,
  },

  // Portal Admins
  PORTAL_ADMINS: {
    ALL: ['portal-admins'] as const,
    LIST: () => ['portal-admins', 'list'] as const,
    DETAIL: (id: string) => ['portal-admins', 'detail', id] as const,
  },

  // Portal Domains
  DOMAINS: {
    ALL: (portalId: string) => ['portals', portalId, 'domains'] as const,
    LIST: (portalId: string) => ['portals', portalId, 'domains', 'list'] as const,
  },

  // SSO Providers
  SSO_PROVIDERS: {
    ALL: (portalId: string) => ['portals', portalId, 'sso-providers'] as const,
    LIST: (portalId: string) => ['portals', portalId, 'sso-providers', 'list'] as const,
  },

  // Master LLM Models
  LLM_MODELS: {
    ALL: ['llm-models'] as const,
    LIST: () => ['llm-models', 'list'] as const,
  },

  // External API
  EXTERNAL_API: {
    ALL: (portalId: string) => ['portals', portalId, 'external-api'] as const,
    CONFIG: (portalId: string) => ['portals', portalId, 'external-api', 'config'] as const,
  },

  // System Analytics
  ANALYTICS: {
    SYSTEM: ['analytics', 'system'] as const,
  },
};
